import { combineForms } from 'react-redux-form'
import { routerReducer } from 'react-router-redux'

import events from './events'
import addEvent from './addEvent'
import eventDetails from './eventDetails'
import errors from '../shared/errors'
import lookupData from '../profile/lookupData'

const storeReducers = combineForms({
  addEvent,
  events,
  eventDetails,
  errors,
  lookupData,
  router: routerReducer
})

export default storeReducers
